import { useState } from "react";
import { useAppStore } from "@/lib/store";
import { Button } from "../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../components/ui/dialog";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Settings } from "lucide-react";

export function SettingsDialog() {
  const { apiToken, apiUrl, setApiToken, setApiUrl } = useAppStore();
  const [token, setToken] = useState(apiToken || "");
  const [url, setUrl] = useState(apiUrl);
  const [open, setOpen] = useState(false);

  const handleSave = () => {
    setApiToken(token.trim() || null);
    setApiUrl(url.trim() || "http://localhost:8080");
    setOpen(false);
  };

  const handleLogout = () => {
    setApiToken(null);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="icon" className="h-9 w-9">
          <Settings className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-xl">Settings</DialogTitle>
          <DialogDescription>
            Configure your API connection settings and authentication.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-5 py-4">
          <div className="space-y-2">
            <Label htmlFor="settings-api-url" className="text-sm font-medium">
              API URL
            </Label>
            <Input
              id="settings-api-url"
              type="text"
              placeholder="http://localhost:8080"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              className="h-10"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="settings-api-token" className="text-sm font-medium">
              API Token
            </Label>
            <Input
              id="settings-api-token"
              type="password"
              placeholder="Enter your bearer token"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              className="h-10"
            />
          </div>
        </div>
        <DialogFooter className="flex justify-between sm:justify-between">
          <Button variant="destructive" onClick={handleLogout} className="sm:w-auto">
            Logout
          </Button>
          <Button onClick={handleSave} className="sm:w-auto">
            Save Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

